<template>
  <div class="imt-audio">
    <div class="audio-wrapper">
      <div class="audio-number">{{currentTime}}</div>
      <van-slider
        class="audio-slider"
        :active-color="color"
        :max="duration*1"
        v-model="current"
        @change="change"
      />
      <!-- <slider
        class="audio-slider"
        :activeColor="color"
        block-size="16"
        :value="current"
        :max="duration"
        @changing="seek=true,current=$event.detail.value"
        @change="change"
      ></slider>-->
      <div class="audio-number">{{durationTime}}</div>
    </div>
    <div class="audio-control-wrapper" :style="{color:color}">
      <div
        class="audio-control audio-control-prev"
        v-if="control"
        :style="{borderColor:color}"
        @click="prev"
      >&#xe601;</div>
      <div
        class="audio-control audio-control-switch"
        :class="{audioLoading:loading}"
        :style="{borderColor:color}"
        @click="operation"
      >{{loading?'&#xe600;':(paused?'&#xe865;':'&#xe612;')}}</div>
      <div
        class="audio-control audio-control-next"
        v-if="control"
        :style="{borderColor:color}"
        @click="next"
      >&#xe601;</div>
    </div>
    <audio
      ref="audio"
      style="display:none;"
      :autoplay="autoplay"
      :obeyMuteSwitch="false"
      :src="src"
      @canplay="handleCanplay"
      @timeupdate="handleTimeupdate"
      @play="handlePlay"
      @pause="handlePause"
      @ended="handleEnded"
      @seeked="handleSeeked"
    ></audio>
  </div>
</template>

<script>
let audio = null;
export default {
  data () {
    return {
      currentTime: this.format(0), //当前播放时间
      durationTime: '', //总时长
      duration: '',
      current: 0, //slider当前进度
      loading: false, //是否处于读取状态
      paused: true, //是否处于暂停状态
      seek: false,//是否处于拖动状态,
      tryTime: this.maxTryTime,
    }
  },
  props: {
    src: String, //音频链接
    autoplay: Boolean, //是否自动播放
    control: {
      type: Boolean,
      default: true
    }, //是否需要上一曲/下一曲按钮
    continue: Boolean,//播放完成后是否继续播放下一首，需定义@next事件
    color: {
      type: String,
      default: '#169af3'
    }, //主色调
    maxTryTime: {
      type: Number,
      default: -1
    }
  },
  methods: {
    //返回prev事件
    prev () {
      this.$emit('prev')
    },
    //返回next事件
    next () {
      this.$emit('next')
    },
    //格式化时长
    format (num) {
      return '0'.repeat(2 - String(Math.floor(num / 60)).length) + Math.floor(num / 60) + ':' + '0'.repeat(2 - String(
        Math.floor(num % 60)).length) + Math.floor(num % 60)
    },
    //播放/暂停操作
    operation () {
      if (this.tryTime > -1 && this.current >= this.tryTime) {
        audio.pause()
        this.$emit('prevent', this.tryTime)
      } else if (audio.paused) {
        audio.play()
        this.loading = true
      } else {
        audio.pause()
      }
    },
    //完成拖动事件
    change (value) {
      if (value >= this.tryTime) {
        audio.pause()
        if (value > this.tryTime) {
          audio.currentTime = this.tryTime
        }
        this.$emit('prevent', this.tryTime)
      }
    },
    handleCanplay () {
      this.duration = audio.duration
      this.durationTime = this.format(audio.duration)
    },
    handleTimeupdate () {
      if (!this.seek) {
        this.current = audio.currentTime
        if (this.tryTime > -1 && this.current >= this.tryTime) {
          audio.pause()
          this.$emit('prevent', this.tryTime)
        }
      }
    },
    handlePlay () {
      this.paused = false
      this.loading = false
    },
    handlePause () {
      this.paused = true
    },
    handleEnded () {
      if (this.continue) {
        this.next()
      } else {
        this.paused = true
        this.current = 0
      }
    },
    handleSeeked () {
      this.seek = false
      if (this.tryTime > -1 && this.current >= this.tryTime) {
        audio.pause()
        this.$emit('prevent', this.tryTime)
      }
    }
  },
  mounted () {
    audio = this.$refs.audio
    this.current = 0
    //音频完成更改进度事件
  },
  destroyed () {
    console.log('destroyed')
    audio.pause()
  },
  watch: {
    //监听音频地址更改
    src (e) {
      audio.src = e
      this.current = 0
      audio.play()
      this.loading = true
    },
    //监听当前进度改变
    current (e) {
      let str = this.format(e)
      this.currentTime = str
    },
    maxTryTime (e) {
      this.tryTime = e
    }
  }
}
</script>

<style>
@font-face {
  font-family: "icon";
  src: url("//at.alicdn.com/t/font_1104838_fxzimc34xw.eot");
  src: url("//at.alicdn.com/t/font_1104838_fxzimc34xw.eot?#iefix")
      format("embedded-opentype"),
    url("//at.alicdn.com/t/font_1104838_fxzimc34xw.woff2") format("woff2"),
    url("//at.alicdn.com/t/font_1104838_fxzimc34xw.woff") format("woff"),
    url("//at.alicdn.com/t/font_1104838_fxzimc34xw.ttf") format("truetype"),
    url("//at.alicdn.com/t/font_1104838_fxzimc34xw.svg#iconfont") format("svg");
}

.imt-audio {
  padding: 15px;
  background: #fff;
}

.audio-wrapper {
  display: flex;
  align-items: center;
}

.audio-number {
  font-size: 12px;
  line-height: 1;
  color: #333;
}

.audio-slider {
  flex: 1;
  margin: 0 15px;
}

.audio-control-wrapper {
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "icon" !important;
}

.audio-control {
  font-size: 16px;
  line-height: 1;
  border: 2px solid;
  border-radius: 50%;
  padding: 8px;
}

.audio-control-next {
  transform: rotate(180deg);
}

.audio-control-switch {
  font-size: 20px;
  margin: 0 20px;
}

.audioLoading {
  animation: loading 2s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

@keyframes loading {
  to {
    transform: rotate(360deg);
  }
}
</style>